import { render, staticRenderFns } from "./HeadingCard.vue?vue&type=template&id=16ef71a5&scoped=true&"
import script from "./HeadingCard.vue?vue&type=script&lang=js&"
export * from "./HeadingCard.vue?vue&type=script&lang=js&"
import style0 from "./HeadingCard.vue?vue&type=style&index=0&id=16ef71a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef71a5",
  null
  
)

export default component.exports